import './css/custom.scss'

import 'jquery'
window.$ = $;

import 'bootstrap'

import './js/partnerYellowMap'